<template>
  <div>
    <b-modal
      id="modal-prevent-closing-deposit"
      ref="modal-deposit"
      v-model="showModal"
      hide-footer
      centered
    >
      <template #modal-title> Add Budget </template>

      <validation-observer ref="deposit">
        <b-form class="auth-add-user-form my-2" @submit.prevent="deposit">
          <b-form-group
            label="Enter your deposit amount ($)"
            label-for="amount"
          >
            <validation-provider
              #default="{ errors }"
              name="amount"
              vid="amount"
              rules="required|max-value:1000000"
            >
              <b-form-input
                autocomplete="on"
                id="amount"
                v-model="amount"
                name="amount"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label-for="type"
            class="w-100"
            label="Choose a payment method"
          >
            <b-row>
              <b-col
                class="d-flex px-50"
                md="4"
                cols="6"
                v-for="(item, index) in types"
                :key="index"
              >
                <div
                  @click="
                    type = item.value;
                    currency = item.currency ? item.currency : '';
                  "
                  :class="`shadow-lg rounded ${
                    type == item.value ? '  selected ' : ' opacity-50 '
                  } cursor-pointer bg-secondary  d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                  style="height: 80px"
                >
                  <b-badge
                    v-if="type == item.value"
                    variant="warning"
                    class="rounded-circle p-25"
                    style="position: absolute; top: -15px; right: 20px"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      style="width: 12px; height: 12px"
                    />
                  </b-badge>
                  <b-img
                    :alt="item.title"
                    :src="item.img"
                    fluid
                    style="max-height: 40px"
                  />
                </div>
              </b-col>
              <b-col class="d-flex" cols="12">
                <div
                  @click="
                    type = crypto.value;
                    currency = crypto.currency ? crypto.currency : '';
                  "
                  :class="`shadow-lg rounded ${
                    type == crypto.value ? 'border-warning' : 'border'
                  } cursor-pointer d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                  style="height: 80px"
                >
                  <b-badge
                    v-if="type == crypto.value"
                    variant="warning"
                    class="rounded-circle p-25"
                    style="position: absolute; top: -15px; right: 20px"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      style="width: 12px; height: 12px"
                    />
                  </b-badge>
                  <h3>
                    {{ crypto.title }}
                  </h3>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
          <b-button
            block
            type="submit"
            class="my-1 gradient-btn"
            
          >
            Deposit
          </b-button>
        </b-form>
      </validation-observer>
      <loader :loading="loading" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButtonGroup,
  BButton,
  BForm,
  BBadge,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BModal,
  BAvatar,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButtonGroup,
    BButton,
    BForm,
    BBadge,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BModal,
    Loader,
    BAvatar,
  },
  data() {
    return {
      amount: "",
      type: "STRIPE1",
      loading: false,
      currency: "",
      crypto: {
        value: "NOW_PAYMENT1",
        title: "Pay with crypto",
        currency: "usdt",
      },
      types: [
        {
          value: "STRIPE1",
          title: "master card",
          img: require("@/assets/images/fxlegends/MasterCard-Logo-1990.png"),
        },
        {
          value: "STRIPE2",
          title: "visa card",
          img: require("@/assets/images/fxlegends/Visa_Inc._logo.svg.png"),
        },
        {
          value: "STRIPE3",
          title: "debit card",
          img: require("@/assets/images/fxlegends/debit.png"),
        },
        // {
        //   value: "NOW_PAYMENT1",
        //   title: "tether",
        //   img: require("@/assets/images/fxlegends/tether-1.svg"),
        //   currency: "usdt",
        // },
        // {
        //   value: "NOW_PAYMENT2",
        //   title: "btc",
        //   img: require("@/assets/images/fxlegends/btc1.png"),
        //   currency: "btc",
        // },
        // {
        //   value: "NOW_PAYMENT3",
        //   title: "etc",
        //   img: require("@/assets/images/fxlegends/etc.png"),
        //   currency: "etc",
        // },
      ],
      required,
    };
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deposit() {
      this.$refs.deposit.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            let pay = {
              amount: Number(this.amount),
              type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
            };
            !this.type.includes("STRIPE") && (pay.currency = this.currency);

            const { data } = await this.$http.post(
              "/panel/profile/user/wallet",
              { ...pay }
            );
            window.location.assign(data.payment.url);
          } catch (err) {}

          this.loading = false;
          this.showModal = false;
        }
      });
    },
  },
};
</script>
